import { render, staticRenderFns } from "./Top20Card.vue?vue&type=template&id=186da41a&"
import script from "./Top20Card.vue?vue&type=script&lang=js&"
export * from "./Top20Card.vue?vue&type=script&lang=js&"
import style0 from "./Top20Card.vue?vue&type=style&index=0&id=186da41a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports